import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "middleware/Interceptor";
//import 'simplebar/dist/simplebar.css';
import 'simplebar-react/dist/simplebar.min.css';


import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import "bootstrap/dist/css/bootstrap.min.css";
import "./i18nextConf";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Toaster />
    <App />
  </BrowserRouter>
);
